import { appstr } from "./appstr";
import { Globals } from "../CoreApp/Globals";
import { handledosave2 } from "./handledosave2";

export function handledosave() {
  var w = Globals._wsMgr;
  //  var theDoc = w.GetDoc();
  var docMgr = w.GetDocMgr();
  var wasMaster = docMgr.IsBackground(null);

  var fileName = w["fileName"];
  var directory = w["directory"];

  // var d1 = new Date();
  // var s1 = d1.getTime();

  var jData = docMgr.SaveDocument(w.GetAccountName(), fileName, directory, w["saveScope"]);

  //var d2 = new Date();
  //var s2 = d2.getTime();
  //var elapsed = s2 - s1;
  //console.log("Save [1] time: " + elapsed);

  w.HandleMasterMode(wasMaster);
  w["jbuffer"] = jData;

  if (!docMgr.fSaveInProgress) {
    var a = appstr("saving2");
    w.DoProgress(a);
  }
  setTimeout(function () {
    handledosave2();
  }, 3);
}
